/**
 * Entitlements (US-512 — chantier « entitlements réels »).
 *
 * Pont entre les flags décidés par Lil & Co dans le SuperAdmin (table
 * `tenant_features`) et le COMPORTEMENT réel du produit (site / admin / tablette).
 *
 * Modèle :
 *  - `isEntitled` = Lil & Co AUTORISE-t-il cette capacité pour ce resto ?
 *    → rétro-compatible : un flag absent OU `true` = autorisé ; seul `false`
 *      (désactivation explicite par le SuperAdmin) bloque. Les restos existants,
 *      sans aucune ligne `tenant_features`, gardent donc EXACTEMENT le comportement
 *      actuel (aucune régression).
 *  - `gateFeature` = capacité EFFECTIVE = autorisée (entitlement) ET configurée
 *    côté resto (colonne native : delivery_enabled, stripe_charges_enabled, …).
 *
 * Pur et testable — aucune I/O ici (le chargement vit dans featuresService.ts).
 */
import type { FeatureKey, TenantFeatures } from './superAdmin';

/**
 * Lil & Co autorise-t-il cette capacité pour le resto ?
 * Absent / true → autorisé ; false → bloqué explicitement par le SuperAdmin.
 */
export function isEntitled(features: TenantFeatures, key: FeatureKey): boolean {
  return features[key] !== false;
}

/**
 * Capacité EFFECTIVE pour le client : autorisée par Lil & Co ET activée par le resto.
 * `nativelyEnabled` = la config native du tenant (ex. `tenant.delivery_enabled`).
 */
export function gateFeature(
  features: TenantFeatures,
  key: FeatureKey,
  nativelyEnabled: boolean | null | undefined,
): boolean {
  return Boolean(nativelyEnabled) && isEntitled(features, key);
}
